/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NotificationScheduleDto
 */
export interface NotificationScheduleDto {
    /**
     *
     * @type {number}
     * @memberof NotificationScheduleDto
     */
    notificationScheduleId?: number;
    /**
     *
     * @type {string}
     * @memberof NotificationScheduleDto
     */
    scheduleType?: NotificationScheduleDtoScheduleTypeEnum;
    /**
     *
     * @type {string}
     * @memberof NotificationScheduleDto
     */
    scheduledTime?: string;
    /**
     *
     * @type {number}
     * @memberof NotificationScheduleDto
     */
    daysOfWeek?: number;
    /**
     *
     * @type {number}
     * @memberof NotificationScheduleDto
     */
    dayOfMonth?: number;
    /**
     *
     * @type {number}
     * @memberof NotificationScheduleDto
     */
    intervalValue?: number;
    /**
     *
     * @type {string}
     * @memberof NotificationScheduleDto
     */
    intervalUnit?: NotificationScheduleDtoIntervalUnitEnum;
    /**
     *
     * @type {string}
     * @memberof NotificationScheduleDto
     */
    timeZone?: string;
    /**
     *
     * @type {Date}
     * @memberof NotificationScheduleDto
     */
    nextScheduledRun?: Date;
}

/**
 * @export
 */
export const NotificationScheduleDtoScheduleTypeEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Interval: "Interval",
} as const;
export type NotificationScheduleDtoScheduleTypeEnum =
    (typeof NotificationScheduleDtoScheduleTypeEnum)[keyof typeof NotificationScheduleDtoScheduleTypeEnum];

/**
 * @export
 */
export const NotificationScheduleDtoIntervalUnitEnum = {
    Minutes: "Minutes",
    Hours: "Hours",
    Days: "Days",
    Weeks: "Weeks",
    Months: "Months",
} as const;
export type NotificationScheduleDtoIntervalUnitEnum =
    (typeof NotificationScheduleDtoIntervalUnitEnum)[keyof typeof NotificationScheduleDtoIntervalUnitEnum];

/**
 * Check if a given object implements the NotificationScheduleDto interface.
 */
export function instanceOfNotificationScheduleDto(
    value: object,
): value is NotificationScheduleDto {
    return true;
}

export function NotificationScheduleDtoFromJSON(
    json: any,
): NotificationScheduleDto {
    return NotificationScheduleDtoFromJSONTyped(json, false);
}

export function NotificationScheduleDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NotificationScheduleDto {
    if (json == null) {
        return json;
    }
    return {
        notificationScheduleId:
            json["notificationScheduleId"] == null
                ? undefined
                : json["notificationScheduleId"],
        scheduleType:
            json["scheduleType"] == null ? undefined : json["scheduleType"],
        scheduledTime:
            json["scheduledTime"] == null ? undefined : json["scheduledTime"],
        daysOfWeek: json["daysOfWeek"] == null ? undefined : json["daysOfWeek"],
        dayOfMonth: json["dayOfMonth"] == null ? undefined : json["dayOfMonth"],
        intervalValue:
            json["intervalValue"] == null ? undefined : json["intervalValue"],
        intervalUnit:
            json["intervalUnit"] == null ? undefined : json["intervalUnit"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        nextScheduledRun:
            json["nextScheduledRun"] == null
                ? undefined
                : new Date(json["nextScheduledRun"]),
    };
}

export function NotificationScheduleDtoToJSON(
    value?: NotificationScheduleDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        notificationScheduleId: value["notificationScheduleId"],
        scheduleType: value["scheduleType"],
        scheduledTime: value["scheduledTime"],
        daysOfWeek: value["daysOfWeek"],
        dayOfMonth: value["dayOfMonth"],
        intervalValue: value["intervalValue"],
        intervalUnit: value["intervalUnit"],
        timeZone: value["timeZone"],
        nextScheduledRun:
            value["nextScheduledRun"] == null
                ? undefined
                : value["nextScheduledRun"].toISOString(),
    };
}
